<div class="mn-body template-minimal">
  <div class="container">
    <div class="template_mn">

      <!-- Dynamic template name badge -->
      <div class="mn-type-badge">{{ templateName }}</div>

      <!-- Profile -->
      <header class="mn-head">
        <div class="mn-avatar"><img [src]="imageSrc" alt="profileImage" /></div>
        <h1>{{ firstName + ' ' + lastName }}</h1>
        <p class="mn-job">{{ jobTitle }}<span *ngIf="companyName"> — {{ companyName }}</span></p>
      </header>

      <div class="mn-about" *ngIf="content" [innerHTML]="content"></div>

      <div class="mn-facts" *ngIf="gpa || school || grade || height || age || weight">
        <span *ngIf="gpa"><b>GPA</b> {{ gpa }}</span>
        <span *ngIf="school"><b>School</b> {{ school }}</span>
        <span *ngIf="grade"><b>Grade</b> {{ grade }}</span>
        <span *ngIf="height"><b>Height</b> {{ height }}</span>
        <span *ngIf="age"><b>Age</b> {{ age }}</span>
        <span *ngIf="weight"><b>Weight</b> {{ weight }}</span>
      </div>

      <!-- Links: sirf text rows -->
      <nav class="mn-links" *ngIf="buttons && buttons.length > 0 && buttons[0].LinkButtonTitle">
        <ng-container *ngFor="let button of buttons">
          <a class="mn-link" *ngIf="button" [href]="button.LinkButtonLink" target="_blank">
            <span class="mn-link-title">{{ button.LinkButtonTitle }}</span>
            <i class="fa-solid fa-arrow-up-right-from-square" [style.color]="buttonColor || null"></i>
          </a>
        </ng-container>
      </nav>

      <!-- VIDEOS: YouTube + Umyotube (YouTube / Dailymotion / umyovideo) + Vimeo -->
      <section class="mn-videos">
        <div class="mn-sec-title" *ngIf="(youtubeArray && youtubeArray.length > 0 && youtubeArray[0].youtubeLink) || (vimeoArray && vimeoArray.length > 0 && vimeoArray[0].vimeoVideoLink) || (umyotubeArray && umyotubeArray.length > 0 && umyotubeArray[0].umyotubeLink)">
          <i class="fa-solid fa-circle-play"></i> Video
        </div>

        <ng-container *ngFor="let v of youtubeArray">
          <div class="mn-video" *ngIf="v.youtubeLink | videoEmbed as src">
            <p class="mn-video-title"><i class="fa-brands fa-youtube"></i> {{ v.youtubeTitle }}</p>
            <div class="mn-embed">
              <iframe [src]="src" [title]="v.youtubeTitle || 'YouTube player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of umyotubeArray">
          <div class="mn-video" *ngIf="v.umyotubeLink | videoEmbed as src">
            <p class="mn-video-title"><i class="fa-solid fa-circle-play"></i> {{ v.umyotubeTitle }}</p>
            <div class="mn-embed">
              <iframe [src]="src" title="Umyotube player" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let v of vimeoArray">
          <div class="mn-video" *ngIf="v.vimeoVideoLink | videoEmbed as src">
            <p class="mn-video-title"><i class="fa-brands fa-vimeo-v"></i> {{ v.vimeoVideoTitle }}</p>
            <div class="mn-embed">
              <iframe [src]="src" [title]="v.vimeoVideoTitle || 'Vimeo player'" frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </ng-container>
      </section>

      <!-- Contact: simple text -->
      <section class="mn-contact">
        <div class="mn-label">Contact</div>
        <a [href]="'tel:' + phone"><span>Phone</span>{{ phone }}</a>
        <a [href]="'sms:' + phone" *ngIf="phoneAllow"><span>Text</span>{{ phone }}</a>
        <a [href]="'mailto:' + email"><span>Email</span>{{ email }}</a>
        <a *ngIf="address" [href]="'https://www.google.com/maps?q=' + address" target="_blank"><span>Address</span>{{ address }}</a>
      </section>

      <!-- Social: text links -->
      <section class="mn-social" *ngIf="instagram || youtube || pinterest || linkedin || facebook || twitter">
        <div class="mn-label">Elsewhere</div>
        <div class="mn-social-row">
        <a [href]="instagram" target="_blank" *ngIf="instagram">Instagram</a>
        <a [href]="youtube" target="_blank" *ngIf="youtube">YouTube</a>
        <a [href]="pinterest" target="_blank" *ngIf="pinterest">Pinterest</a>
        <a [href]="linkedin" target="_blank" *ngIf="linkedin">LinkedIn</a>
        <a [href]="facebook" target="_blank" *ngIf="facebook">Facebook</a>
        <a [href]="twitter" target="_blank" *ngIf="twitter">Twitter</a>
        </div>
      </section>

      <section class="mn-gallery" *ngIf="productImages">
        <img *ngFor="let img of productImages; trackBy: trackByIndex" [src]="img" alt="productImage" />
      </section>

      <div class="mn-ctrls">
        <button type="button" class="ctrl-item" *ngIf="forwardCard" data-bs-toggle="modal" data-bs-target="#shareCard">
          <i class="fa-solid fa-share"></i><h3>Forward</h3>
        </button>
        <a (click)="navigateToHome()" type="button" class="ctrl-item">
          <i class="fa-solid fa-right-to-bracket"></i><h3>Sign Up</h3>
        </a>
        <button type="button" class="ctrl-item" *ngIf="saveCard" (click)="downloadVCard()">
          <i class="fa-solid fa-download"></i><h3>Save My Card</h3>
        </button>
      </div>

      <footer class="mn-footer">
        <img class="mn-qr" *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
        <p class="mn-strip">Simple · Clear · Yours</p>
        <p class="mn-powered">This card is powered by <span>UMYO Cards</span></p>
        <form action="" class="referal-form" *ngIf="inviteCode">
          <label for="referal">Referral ID: </label>
          <input type="text" name="referal" id="referal" [value]="referal" disabled placeholder="XXXXX" />
        </form>
        <a [routerLink]="['/']" class="call-to-action">
          <span class="left">Click<br />Here</span>
          <span class="right">Design your card now!</span>
        </a>
      </footer>

    </div>
  </div>
</div>